import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ApiService } from './api.service';
import { ApiUrl } from './apiUrl';
import { saveBlobAsFile } from './file-download.util';

export type ReferenceImportMode = 'merge' | 'replace';

export interface DskGroupSearchItem {
  _id: string;
  mainGroup: string;
  productGroup: string;
  subGroup: string;
  dskAssortmentID: string;
  family: string;
  discountGroup: string;
}

export interface VendorSearchItem {
  _id: string;
  vendorID: string;
  vendorName: string;
}

@Injectable({
  providedIn: 'root'
})
export class GlobalReferenceService {

  constructor(private api: ApiService) {}

  downloadDskGroupsTemplate(): Observable<void> {
    return this.api.getBlobRequest(ApiUrl.globalReferenceDskGroupsTemplate).pipe(
      tap((blob) => saveBlobAsFile(blob, 'dsk-groups-template.csv')),
      map(() => undefined)
    );
  }

  downloadVendorsTemplate(): Observable<void> {
    return this.api.getBlobRequest(ApiUrl.globalReferenceVendorsTemplate).pipe(
      tap((blob) => saveBlobAsFile(blob, 'vendors-template.csv')),
      map(() => undefined)
    );
  }

  importDskGroups(formData: FormData, mode: ReferenceImportMode): Observable<any> {
    return this.api.postRequest(`${ApiUrl.globalReferenceDskGroupsImport}?mode=${mode}`, formData);
  }

  importVendors(formData: FormData, mode: ReferenceImportMode): Observable<any> {
    return this.api.postRequest(`${ApiUrl.globalReferenceVendorsImport}?mode=${mode}`, formData);
  }

  searchDskGroups(params: {
    q?: string;
    mainGroup?: string;
    productGroup?: string;
    subGroup?: string;
    limit?: number;
  }): Observable<{ items: DskGroupSearchItem[]; total: number }> {
    const search = new URLSearchParams();
    if (params.q) search.set('q', params.q);
    if (params.mainGroup) search.set('mainGroup', params.mainGroup);
    if (params.productGroup) search.set('productGroup', params.productGroup);
    if (params.subGroup) search.set('subGroup', params.subGroup);
    search.set('limit', String(params.limit ?? 50));
    const qs = search.toString();
    const url = qs ? `${ApiUrl.globalReferenceDskGroupsSearch}?${qs}` : ApiUrl.globalReferenceDskGroupsSearch;
    return this.api.getRequest(url).pipe(
      map((res: any) => {
        const data = res?.response?.data ?? res?.data ?? {};
        return {
          items: data.items || [],
          total: data.total ?? 0
        };
      })
    );
  }

  searchVendors(q: string, limit: number = 50): Observable<{ items: VendorSearchItem[]; total: number }> {
    const search = new URLSearchParams();
    if (q) search.set('q', q);
    search.set('limit', String(limit));
    const url = `${ApiUrl.globalReferenceVendorsSearch}?${search.toString()}`;
    return this.api.getRequest(url).pipe(
      map((res: any) => {
        const data = res?.response?.data ?? res?.data ?? {};
        return {
          items: data.items || [],
          total: data.total ?? 0
        };
      })
    );
  }
}
